import dayjs from "dayjs";
export const getUtcOffset = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!!timezone)
        return timezone;
    let utcOffsetBrut = Math.ceil(dayjs().toDate().getTimezoneOffset() / 60);
    // add summertime compatibility
    if (utcOffsetBrut < 0)
        utcOffsetBrut -= 1;
    let currentUtcOffset = utcOffsetBrut <= 0 ? "+" : "-";
    currentUtcOffset += dayjs()
        .hour(0)
        .minute(0)
        .add(utcOffsetBrut >= 0 ? utcOffsetBrut : utcOffsetBrut * -1, "hour")
        .format("HH");
    return currentUtcOffset;
};
//# sourceMappingURL=getUtcOffset.js.map